export const SINGLE_OPTION_MARKETS = ['match', 'halftime', 'nextGoal', 'btts'];
export const marketDisplayName = {
    match: 'Full time',
    halftime: 'Half time',
    nextGoal: 'Next goal',
    btts: 'Both teams to score',
    goals: 'Total goals',
    score: 'Correct score'
};

export const commonOutcome = Symbol('common');
export const emptyValue = Symbol(null);



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/constants.js
 **/